import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        notPermissionAccess: {
          TRIAL_NOT_PERMISSION_CONTENT: `Your trial account has no access to this company's information. Click  %{link} to see a list of companies that you can view details.`,
          TRIAL_UPGRADE_CONTENT: `%{link} to advanced plans to get unlimited view.`,
          UPGRADE_CONTENT: `Your account has no access to this information. %{link} to advanced plans to get unlimited view.`,
          HERE: 'here',
          UPGRADE: 'Upgrade',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        notPermissionAccess: {
          TRIAL_NOT_PERMISSION_CONTENT: `Tài khoản dùng thử của bạn không có quyền truy cập vào thông tin của công ty này. Bấm vào %{link} để xem danh sách các công ty mà bạn được cấp quyền xem chi tiết.`,
          TRIAL_UPGRADE_CONTENT: `%{link} tài khoản để được truy cập không giới hạn.`,
          UPGRADE_CONTENT: `Tài khoản của bạn không có quyền truy cập vào thông tin này. %{link} để được truy cập không giới hạn.`,
          HERE: 'đây',
          UPGRADE: 'Nâng cấp',
        },
      },
    },
  }),
)
